"use strict";
import classNames from "classnames";
import documentFormatter from "../../formatters/documents";
import Account from "../../api/account";
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, _.map(this.activeTypes(), this.typeSelector));
  },
  componentDidMount() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  handleKeydown(e) {
    if (!Account.useDocumentTypeHotkeys()) {
      return;
    }
    var code = e.code;
    var types = this.activeTypes();
    var type = null;
    if (code === "Enter" || code === "NumpadEnter") {
      var doc = this.props.document;
      var suggested = doc.data.document_type;
      type = types.find((type2) => type2.value === suggested);
      this.props.handleEnterPress(type);
    } else if (code.match(/Numpad(\d)/)) {
      var digit = code.split("Numpad")[1];
      type = types[digit - 1];
      if (type) {
        this.setType(type.value, type.name);
      }
    }
  },
  activeTypes() {
    return this.documentTypeTransformer()(
      documentFormatter.activeTypes()
    );
  },
  documentTypeTransformer() {
    return this.props.documentTypesTransformer || _.identity;
  },
  typeSelector: function(type, index) {
    var doc = this.props.document;
    var classes = classNames({
      selected: doc.type === type.value,
      guessed: doc.data && doc.data.document_type === type.value,
      "document-indexer__type": true
    });
    var showHotkeyHint = Account.useDocumentTypeHotkeys() && index < 9;
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: classes,
        key: type.value,
        onClick: () => {
          this.setType(type.value, type.name);
        }
      },
      type.name,
      showHotkeyHint ? /* @__PURE__ */ React.createElement("span", { className: "document-indexer__hotkey-hint" }, index + 1) : null
    );
  },
  setType: function(type, type_name) {
    this.props.onTypeSet(this.props.document, type, type_name);
  }
});
